import React from "react"
import {SbDialog} from "../../../commons/sb-dialog";
import {t, Trans} from "@lingui/macro";
import {Checkbox, FormControlLabel, Typography} from "@mui/material";

interface InfoMessageSearchFormProps {
    onClose: () => void
    confirm: (show: boolean) => void
}

interface InfoMessageSearchFormState {
    show: boolean
}

export class InfoMessageSearchForm extends React.Component<InfoMessageSearchFormProps, InfoMessageSearchFormState>
{
    constructor(props: InfoMessageSearchFormProps) {
        super(props);
        this.state = {
            show: false,
        }
    }

    private confirmAndSave = () => {
        this.props.confirm(this.state.show)
    }

    private toggleCheckbox = () => {
        this.setState(() => ({
            show: !this.state.show,
        }))
    }

    render() {
        return (
            <SbDialog width={"md"}
                      onClose={this.props.onClose}
                      titleText={t({id: "info-message-search-form.title", message: "Informativa sulle funzionalità"})}
                      confirmAndSaveButton
                      closeButton
                      onConfirm={this.confirmAndSave}
            >
                <Typography fontSize={17} fontWeight={400}>
                    <Trans id={"info-message-search-form.body"}>
                        È importante comprendere le distinte finalità dietro le due funzionalità "salva ricerca" e "cerca". Entrambe
                        coinvolgono i match, ma servono a scopi distinti.<br />
                        "Salva ricerca" genera nuove corrispondenze in base ai criteri inseriti, ampliando l'ambito della tua esplorazione.<br />
                        "Cerca" è pensato per individuare match già presenti nel sistema che siano concordi ai criteri inseriti.
                    </Trans>
                </Typography>
                <FormControlLabel control={<Checkbox onChange={(e) => this.toggleCheckbox()}
                                                     checked={this.state.show}/>}
                                  label={t({id: "info-message-search-form.dont-show-again", message: "Non visualizzare di nuovo questo messaggio"})}
                />
            </SbDialog>
        )
    }
}
